import { render, staticRenderFns } from "./magnify.vue?vue&type=template&id=2ef93a32&scoped=true&"
import script from "./magnify.vue?vue&type=script&lang=js&"
export * from "./magnify.vue?vue&type=script&lang=js&"
import style0 from "./magnify.vue?vue&type=style&index=0&id=2ef93a32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef93a32",
  null
  
)

export default component.exports